<template>
  <v-app class="pgs-admin-system">
    <!-- AppBar Modernizado -->
    <v-app-bar app dense flat :color="$pgsHelper.uiConfig().mainColor" dark clipped-left class="modern-app-bar">
      <!-- Ícono de menú -->
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" class="ml-1" />

      <!-- Título con Tipografía Mejorada -->
      <v-toolbar-title class="text-truncate font-weight-bold letter-spacing-tight">
        {{ $pgsHelper.uiConfig().appName }}
      </v-toolbar-title>

      <v-spacer />

      <!-- Favoritos con Estilo de Pastilla -->
      <v-slide-group v-if="$vuetify.breakpoint.mdAndUp" show-arrows style="max-width: 65%">
        <v-slide-item v-for="fav in favoriteItems" :key="fav.route">
          <v-btn text small class="mx-1 modern-fav-btn text-none" @click="goFavoriteRoute(fav.route)">
            <v-icon left size="16" color="amber lighten-2">
              {{ fav.icon || "mdi-star" }}
            </v-icon>
            <span class="font-weight-medium">
              {{ fav.title }}
            </span>
          </v-btn>
        </v-slide-item>
      </v-slide-group>

      <!-- Menú Móvil de Favoritos -->
      <v-menu v-else bottom left offset-y :close-on-content-click="false" content-class="modern-glass-menu">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-star-box-multiple-outline</v-icon>
          </v-btn>
        </template>
        <v-list dense class="py-2">
          <v-list-item v-for="fav in favoriteItems" :key="fav.route" @click="goFavoriteRoute(fav.route)" class="my-1">
            <v-list-item-icon class="mr-3">
              <v-icon color="amber darken-2" small>{{ fav.icon || "mdi-star" }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="text-truncate font-weight-bold caption">
                {{ fav.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <!-- NavDrawer Modernizado -->
    <v-navigation-drawer app :color="this.$pgsHelper.uiConfig().mainColor" dark temporary v-model="drawer" width="300"
      class="modern-drawer">
      <!-- Perfil de Usuario Rediseñado -->
      <div class="pa-6 user-profile-card">
        <v-list dense flat class="pa-0 transparent">
          <v-list-item class="px-0">
            <v-list-item-avatar size="56" color="rgba(255,255,255,0.15)" class="elevation-4 border-white">
              <v-icon x-large color="white">mdi-account-circle-outline</v-icon>
            </v-list-item-avatar>
            <v-list-item-content class="ml-1">
              <v-list-item-title class="text-h6 font-weight-black white--text line-height-tight text-truncate"
                style="white-space: normal !important;">
                {{ claims.name }}
              </v-list-item-title>
              <v-list-item-subtitle class="caption white--text opacity-70 font-weight-medium mt-1">
                {{ claims.Type }}
              </v-list-item-subtitle>
              <div class="d-flex align-center mt-2">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                      v-bind="attrs"
                      v-on="on"
                      x-small
                      outlined
                      color="white"
                      class="version-chip cursor-pointer text-caption px-2"
                      style="cursor: pointer; opacity: 0.85;"
                      @click="showChangelog = true"
                    >
                      <v-icon left x-small>mdi-sparkles</v-icon>
                      v{{ version }}
                    </v-chip>
                  </template>
                  <span>Ver novedades de la versión {{ version }}</span>
                </v-tooltip>
                <v-spacer />
                <v-progress-circular v-if="getStatusLoading" indeterminate size="12" width="2"
                  color="white"></v-progress-circular>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <!-- Botón de Salida Integrado -->
        <v-btn block x-small outlined color="white" class="mt-4 logout-btn-safe text-none" @click="logout">
          <v-icon left size="14">mdi-power</v-icon>
          Cerrar Sesión
        </v-btn>
      </div>

      <div class="px-5">
        <v-divider class="opacity-15"></v-divider>
      </div>

      <!-- Menú de Navegación -->
      <v-list class="pad-bot px-4 nav-content" dense nav>
        <!-- Buscador Modernizado -->
        <v-text-field prepend-inner-icon="mdi-magnify" placeholder="Buscar servicios..." hide-details flat solo-inverted
          dense v-model="filterMenu" class="modern-search-field mb-4"></v-text-field>

        <!-- NO TOCAR EL TREEVIEW (TEMPLATE ORIGINAL PRESERVADO) -->
        <v-treeview return-object @update:active="clickOnNode" activatable color="white" :open-on-click="true"
          item-text="title" :items="menuFiltered" item-children="childs">

          <template v-slot:label="{ item }">
            <v-hover v-slot="{ hover }" open-delay="200">
              <v-list-item-content style="  white-space: normal !important;">
                <v-list-item-subtitle v-if="item.parentName && filterMenu != ''" class="parentName">
                  {{ item.parentName }}</v-list-item-subtitle>
                <p class="my-0"><span class="caption" v-if="(!item.childs || !item.childs.length) & hover">
                    <v-icon v-if="(!item.childs || !item.childs.length)" small
                      :color="isFavorito(item) ? 'yellow' : 'grey lighten-1'" @click.stop="toggleFavorito(item)"
                      title="Marcar como favorito">
                      {{ isFavorito(item) ? "mdi-star" : "mdi-star-outline" }}
                    </v-icon> -

                  </span> <v-icon>
                    {{ item.icon }}
                  </v-icon> {{ item.title }}</p>
              </v-list-item-content>
            </v-hover>
          </template>
        </v-treeview>
      </v-list>

      <v-row v-if="loadingMenu" class="loading-overlay" align-content="center" justify="center">
        <v-progress-circular indeterminate color="white" size="24"></v-progress-circular>
      </v-row>
    </v-navigation-drawer>

    <!-- Área de Contenido -->
    <v-main class="pgs-bg-gradient">
      <v-container fluid class=" pb-16">
        <!-- Loader Global de Componentes -->
        <v-row v-if="loadingRouteComponent" class="loader-wrapper" align-content="center" justify="center">
          <v-col class="text-center" cols="12">
            <v-progress-circular size="64" width="3" color="primary" indeterminate class="mb-4">
              <v-icon color="primary" size="24">mdi-golf</v-icon>
            </v-progress-circular>
            <div class="text-h6 font-weight-light primary--text">Preparando tu acceso...</div>
          </v-col>
        </v-row>

        <v-alert v-if="false" type="warning" border="left" class="elevation-2 rounded-lg mb-6">
          La fecha límite de pago se acerca. A partir de entonces, la funcionalidad será limitada.
        </v-alert>

        <!-- Vista de Rutas -->

        <router-view v-show="!loadingRouteComponent" :key="indexComponent" @changeIndex="changeIndexComponent"
          @startLoading="startLoading" @endLoading="endLoading"></router-view>


        <!-- Landing Placeholder Minimalista -->
        <div v-if="$route.name == 'landing-page' && !hotelAccess && !loadingRouteComponent" class="hero-landing mt-12">
          <v-row justify="center">
            <v-col cols="12" md="10" lg="8" class="text-center">
              <div class="pa-10 pa-md-16 rounded-xl elevation-0">
                <v-icon color="primary" size="80" class="mb-6 opacity-40">mdi-golf-tee</v-icon>
                <h1 class="text-h2 font-weight-black mb-4 primary--text line-height-tight">
                  Bienvenido
                </h1>
                <p class="text-h6 font-weight-light grey--text text--darken-2 mb-10 max-width-center">
                  Utilice el menú lateral para acceder a las herramientas de gestión de su campo de golf.
                </p>
                <v-btn large color="primary" depressed class="rounded-lg px-8 py-6" @click="drawer = true">
                  <v-icon left>mdi-menu-open</v-icon>
                  Explorar Módulos
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-main>

    <!-- Modal de Novedades del Sistema (Changelog) -->
    <Releases
      v-model="showChangelog"
      :current-version="version"
      @close="onCloseChangelog"
    />
  </v-app>
</template>

<script>
import Vue from "vue";
import Permisos from "../../clases/Permisos.js";
//import MenuItemTree from "../MainComponents/MenuItemTree.vue";
import Releases from "./Releases.vue";
import { version } from "../../../package";
import { mapGetters } from "vuex";
const userPermissions = new Permisos("Admin");
export default {
  name: "LandingVuetify",
  components: {
    Releases,
    //MenuItemTree,
  },
  props: ["type"],
  data() {
    return {
      showChangelog: false,
      loadingMenu: true,
      loadingRouteComponent: false,
      universalDepartment: userPermissions.universalDepartment,
      MainDepartamento: "",
      parentBus: new Vue(),
      showMenu: false,
      indexComponent: 1,
      access: [],
      fullAccess: false,
      hotelAccess: false,
      guardiaAccess: false,
      selectedMenu: 0,
      claims: {},
      viewQuickSearch: false,
      viewCreate: false,
      viewList: true,
      tabs: null,
      drawer: null,
      menuV2: [],
      filterMenu: "",
      miniDrawerItems: [
        { title: "Dashboard", icon: "fal fa-chart-bar" },
        { title: "Content", icon: "fal fa-file" },
        { title: "Articles", icon: "fal fa-pencil-alt" },
        { title: "Properties", icon: "fal fa-home-alt" },
        { title: "Users", icon: "fal fa-user-circle" },
        { title: "Settings", icon: "fal fa-cog" },
      ],
      expandedDrawerItems: [
        { type: "heading", title: "Content", icon: "fal fa-file" },
        { type: "divider" },
        { type: "button", title: "New Content", icon: "fal fa-plus-circle" },
        { type: "divider" },
        { type: "link", title: "Main Menu", icon: "fal fa-folder" },
        { type: "link", title: "Footer", icon: "fal fa-folder" },
        { type: "divider" },
        { type: "link", title: "Categories", icon: "fal fa-cog" },
      ],
      mini: true,

      favorites: [], // rutas de módulos favoritos
      maxFavorites: 5,
    };
  },
  computed: {
    ...mapGetters(["getStatusLoading"]),
    tenant() {
      if (this.$store.getters.getFirebaseApp.tenant) {
        return this.$store.getters.getFirebaseApp.tenant;
      } else {
        return "";
      }
    },
    menuAllowed() {
      let claims = this.$route.params.user.tokenResult.claims;
      return claims;
    },
    version() {
      return version;
    },
    menuFiltered() {
      if (this.filterMenu == "") {
        return this.menuV2;
      }
      const filteredList = this.filterMenuRecursive(
        this.menuV2,
        this.filterMenu
      );
      let uniqueFilteredMenu = filteredList.filter(
        (obj, index, self) => index === self.findIndex((t) => t.id === obj.id)
      );

      return uniqueFilteredMenu;
    },
    breakpoint() {
      return this.$vuetify.breakpoint;
    },
    favoriteItems() {
      const all = [];
      const recorre = (items) => {
        items.forEach((i) => {
          if (i.route && this.favorites.includes(i.route)) {
            all.push(i);
          }
          if (i.childs) recorre(i.childs);
        });
      };
      recorre(this.menuV2);
      return all;
    },
  },
  methods: {
    isFavorito(item) {
      return this.favorites.includes(item.route);
    },
    toggleFavorito(item) {
      // si tiene hijos, no hacer nada
      if (item.childs && item.childs.length) return;

      const idx = this.favorites.indexOf(item.route);
      if (idx !== -1) {
        this.favorites.splice(idx, 1);
      } else {
        if (this.favorites.length >= this.maxFavorites) {
          this.$swal(
            "Máximo alcanzado",
            `Solo puedes tener hasta ${this.maxFavorites} favoritos.`,
            "warning"
          );
          return;
        }
        this.favorites.push(item.route);
      }
      localStorage.setItem("favoriteModules", JSON.stringify(this.favorites));
    },

    goFavoriteRoute(route) {
      this.goRoute(route);
    },

    clickOnNode(node) {
      if (node[0]) {
        if (node[0].id == "logout") {
          this.logout();
        } else {
          this.goRoute(node[0].route);
        }
      }
    },
    filterMenuRecursive(items, filterText, parentName = null) {
      const normalizedFilter = filterText.toUpperCase();
      let flatList = [];

      items.forEach((item) => {
        if (item.type === "divider") return;
        const itemCopy = { ...item };

        if (parentName) {
          itemCopy.parentName = parentName;
        }
        const selfMatches = itemCopy.title
          .toUpperCase()
          .includes(normalizedFilter);
        const hasChildren = itemCopy.childs && itemCopy.childs.length > 0;

        if (selfMatches) {
          if (hasChildren) {
            // Añadir el padre
            flatList = flatList.concat(this.getChilds(itemCopy));
          } else {
            // Añadir solo el hijo
            flatList.push(itemCopy);
          }
        } else if (hasChildren) {
          // El item padre no coincide, revisar hijos
          flatList = flatList.concat(
            this.filterMenuRecursive(
              itemCopy.childs,
              filterText,
              itemCopy.title
            )
          );
        } // Si no coincide Y no tiene hijos, no se añade
      });

      return flatList;
    },
    getChilds(itemMenu) {
      let childs = [];
      if (itemMenu.childs && itemMenu.childs.length > 0) {
        itemMenu.childs.forEach((menuChild) => {
          const childCopy = { ...menuChild, parentName: itemMenu.title };
          childs = childs.concat(this.getChilds(childCopy));
        });
        return childs;
      } else {
        childs.push(itemMenu);
        return childs;
      }
    },
    startLoading() {
      this.loadingRouteComponent = true;
    },
    endLoading() {
      this.loadingRouteComponent = false;
    },
    async logout() {
      this.$swal({
        title: "Cerrar Sesión",
        text: "¿Estas seguro que deseas salir del sistema?",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Cerrar Sesión",
        showLoaderOnConfirm: true,
      }).then(async (result) => {
        if (result.value) {
          await this.$store.state.FirebaseApp.firebaseApp.auth.signOut();
          //indexedDB.deleteDatabase("pdvDB");
          location.reload();
        }
      });
    },
    openTab() {
      //this.selectedItem.Transportacion.Confirmacion
      window.open("/reservar_transportacion/puerto_cancun");
    },
    goRoute(routePath) {
      this.$router.push({ path: routePath }).catch((err) => {
        this.$pgsHelper.catchError(err);
      });
    },
    changeIndexComponent() {
      this.indexComponent++;
    },
    checkVersionUpdate() {
      const lastSeenVersion = localStorage.getItem("pgs_last_seen_version");
      if (lastSeenVersion !== this.version) {
        this.showChangelog = true;
      }
    },
    onCloseChangelog() {
      localStorage.setItem("pgs_last_seen_version", this.version);
      this.showChangelog = false;
    },
  },
  watch: {
    showChangelog(val) {
      if (!val) {
        localStorage.setItem("pgs_last_seen_version", this.version);
      }
    },
  },

  beforeMount: function () {
    this.MainDepartamento = localStorage.getItem("selectedDepartment");
    let claims = this.$route.params.user.tokenResult.claims;
    this.parentBus.$on("menuClick", (type, val) => {
      if (type == "link") {
        this.goRoute(val);
      } else if (type == "custom") {
        if (val == "resTransportacion") {
          this.openTab();
        }
        if (val == "logout") {
          this.logout();
        }
      }
    });
    this.claims = claims;
    if (claims.Type == "Cajero") {
      this.access.push(claims.Data.Department);
    } else if (claims.Type == "Admin") {
      this.fullAccess = true;
    } else if (claims.Type == "Mayorista") {
      this.hotelAccess = true;
    }

    if (claims.Role == "Seguridad_Membresias") {
      this.fullAccess = false;
      this.hotelAccess = false;
      this.guardiaAccess = true;
    }
  },
  mounted: async function () {
    let claims = this.$route.params.user.tokenResult.claims;
    if (claims?.Data?.Only) {
      Object.entries(claims.Data.Only).forEach((item) => {
        if (item[0].includes("AYB") && item[1]) {
          claims.Type = "AYBAdmin";
        }
      });
    }
    this.loadingMenu = true;
    //setTimeout(() => {
    this.menuV2 = await userPermissions.getMenu(claims.Type, {
      MayoristaAdmin: claims.Data ? claims.Data.EsAdmin : false,
    });

    const fav = localStorage.getItem("favoriteModules");
    this.favorites = fav ? JSON.parse(fav) : [];

    this.loadingMenu = false;
    //}, 2000);

    // Validar si existe una nueva versión para mostrar el changelog
    this.checkVersionUpdate();
  },
};
</script>

<style scoped>
/* PGS Modern Design System - Golf Management */
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');

.pgs-admin-system {
  font-family: 'Inter', sans-serif !important;
  background-color: #f7f9fa !important;
}

/* AppBar Styling */
.modern-app-bar {
  backdrop-filter: blur(12px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;
}

.letter-spacing-tight {
  letter-spacing: -0.8px;
}

.modern-fav-btn {
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.08);
  transition: all 0.3s ease;
}

.modern-fav-btn:hover {
  background-color: rgba(255, 255, 255, 0.15);
  transform: translateY(-2px);
}

/* Drawer Styling */
.modern-drawer {
  box-shadow: 10px 0 40px rgba(0, 0, 0, 0.08) !important;
  border-right: none !important;
}

/* Scrollbar Modernizado para el NavDrawer - Mejorado para fácil interacción */
.modern-drawer>>>.v-navigation-drawer__content::-webkit-scrollbar {
  width: 9px;
  transition: all 0.3s ease;
}

.modern-drawer>>>.v-navigation-drawer__content::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 10px;
}

.modern-drawer>>>.v-navigation-drawer__content::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.25);
  border-radius: 10px;
  border: 2px solid transparent;
  background-clip: padding-box;
}

.modern-drawer>>>.v-navigation-drawer__content::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.4);
  background-clip: padding-box;
  width: 10px;
}

.user-profile-card {
  background: rgba(0, 0, 0, 0.04);
}

.border-white {
  border: 2px solid rgba(255, 255, 255, 0.15);
}

.line-height-tight {
  line-height: 1.2;
}

.opacity-70 {
  opacity: 0.7;
}

.opacity-50 {
  opacity: 0.5;
}

.opacity-15 {
  opacity: 0.15;
}

.opacity-40 {
  opacity: 0.4;
}

.logout-btn-safe {
  border-radius: 8px;
  border-width: 1.5px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.modern-search-field>>>.v-input__control {
  border-radius: 10px !important;
}

/* Treeview Styling (Deep Selectors) */
.pgs-treeview-modern>>>.v-treeview-node__root {
  min-height: 44px !important;
  margin-bottom: 4px;
  border-radius: 8px;
  transition: background 0.2s ease;
}

.v-navigation-drawer>>>.v-treeview-node__label {
  font-size: 0.875rem !important;
  font-weight: 500;
}

/* Redisenyo de los items del treeview via CSS */
.pad-bot {
  margin-bottom: 6rem;
}

.parentName {
  font-size: 0.7rem !important;
  color: rgba(255, 255, 255, 0.45) !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
}

.v-application--is-ltr .v-treeview-node__content {
  margin-left: -22px !important;
}

v-treeview-node__content {
  margin-left: -22px !important;
  white-space: normal !important;
}

>>>.v-treeview-node__children {
  margin-left: -10px !important;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.2);
  z-index: 10;
}

/* Content Area */
.pgs-bg-gradient {
  background: radial-gradient(circle at top left, rgba(27, 94, 32, 0.03) 0%, transparent 40%),
    radial-gradient(circle at bottom right, rgba(27, 94, 32, 0.02) 0%, transparent 40%);
}

.loader-wrapper {
  height: 60vh;
}

/* Hero Section */
.uv-card-modern {
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.03);
  overflow: hidden;
}

.accent-text {
  position: relative;
  display: inline-block;
}

.accent-text::after {
  content: '';
  position: absolute;
  bottom: 8px;
  left: 0;
  width: 100%;
  height: 14px;
  background: rgba(var(--v-primary-base), 0.1);
  z-index: -1;
}

.max-width-center {
  max-width: 650px;
  margin: 0 auto;
}

.modern-glass-menu {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(8px);
  border-radius: 12px;
}
</style>
